/* Pawsy subscription portal router — sends the customer to the correct portal
 * (Loop vs Lasso) based on their order's sales channel, looked up server-side by
 * our proxy. Progressive enhancement: needs JS + the API URL. If anything fails,
 * the two-portal fallback cards (rendered in the markup) are shown instead. */
(function () {
  'use strict';

  function initOne(root) {
    var api = (root.getAttribute('data-portal-api') || '').trim();
    var form = root.querySelector('.pl-ms-form');
    var note = root.querySelector('.pl-ms-note');
    var fallback = root.querySelector('.pl-ms-fallback');
    var btn = root.querySelector('.pl-ms-submit');
    var label = root.querySelector('.pl-ms-submit-label');
    if (!form) return;

    function showNote(msg, ok) {
      if (!note) return;
      note.textContent = msg;
      note.className = 'pl-ms-note' + (ok ? ' is-ok' : '');
      note.hidden = false;
    }

    function showFallback() {
      if (fallback) fallback.hidden = false;
    }

    function go(url) {
      showNote('Found it — taking you to your subscription portal…', true);
      window.location.href = url;
    }

    function run(email, order) {
      if (note) note.hidden = true;
      if (fallback) fallback.hidden = true;

      email = (email || '').trim();
      order = (order || '').trim();
      if (!email) { showNote('Please enter the email you used at checkout.'); return; }
      if (!api) { showFallback(); return; }

      var original = label ? label.textContent : '';
      if (btn) btn.disabled = true;
      if (label) label.textContent = 'Checking…';

      var url = api + (api.indexOf('?') === -1 ? '?' : '&') +
        'email=' + encodeURIComponent(email) +
        (order ? '&order=' + encodeURIComponent(order) : '');

      fetch(url, { method: 'GET', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          var b = res.body || {};
          if (res.ok && b.url) { go(b.url); return; }
          if (res.ok && b.system === 'ambiguous') {
            showNote('We found subscriptions under more than one system — pick the right portal below.');
            showFallback();
            return;
          }
          // Known error from the proxy, or an unexpected shape.
          showNote((b && b.error) || "We couldn't match that to a portal. Pick the right one below.");
          showFallback();
        })
        .catch(function () {
          showNote('Something went wrong on our end. Pick your portal below, or email help@pawsylabs.com.');
          showFallback();
        })
        .then(function () {
          if (btn) btn.disabled = false;
          if (label) label.textContent = original;
        });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      run(form.email && form.email.value, form.order && form.order.value);
    });

    // Deep link: ?email=...&order=... auto-routes (e.g. from a help email).
    try {
      var qs = new URLSearchParams(window.location.search);
      var dEmail = (qs.get('email') || '').trim();
      var dOrder = (qs.get('order') || qs.get('nums') || '').trim();
      if (dEmail) {
        if (form.email) form.email.value = dEmail;
        if (form.order) form.order.value = dOrder;
        run(dEmail, dOrder);
      }
    } catch (e1) {}
  }

  function init() {
    var roots = document.querySelectorAll('.pl-ms');
    for (var i = 0; i < roots.length; i++) initOne(roots[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
